import React from 'react'
import injectStyles from 'react-jss'
import { styles } from './style'
import ChatMessage from '../../../../../Components/Chat/ChatMessage/container/ChatMessage'
import { format } from 'date-fns'

const ChatWindow = ({ classes, messages, isLoadedConversations }) => {
  if (!isLoadedConversations) {
    return 'Loading...'
  }

  return (
    <div className={classes.wrapper}>
      {messages.length ? (
        messages.map(message => {
          const {
            text,
            authorId,
            name,
            timestamp,
            status,
            isOwnMessage,
            type,
            fileURL,
            profilePicture,
          } = message

          const time = format(timestamp, 'HH:mm D MMM')
          return (
            <ChatMessage
              key={authorId + timestamp}
              text={text}
              author={name}
              time={time}
              isOwnMessage={isOwnMessage}
              status={status}
              type={type}
              fileURL={fileURL}
              profilePicture={profilePicture}
            />
          )
        })
      ) : (
        <div className={classes.message}>No messages yet!</div>
      )}
    </div>
  )
}

export default injectStyles(styles)(ChatWindow)



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/Chat/ChatWindow/index.js